// hooks/useLiveFormData.ts
import { useGlobalFormContext } from "@/context/FormContext";
import {
  useValuationFormStore,
  ValuationFormValues,
} from "@/store/valuationFormStore";
import { useFormContext } from "react-hook-form";

export const useLiveFormData = () => {
  let formContext: ReturnType<typeof useFormContext<ValuationFormValues>> | null = null;

  // -----------------------------
  // SAFE FORM CONTEXT ACCESS
  // -----------------------------
  try {
    formContext = useFormContext<ValuationFormValues>();
  } catch {
    formContext = null;
  }

  const { formData: storeData } = useValuationFormStore();
  const { isFormDirty } = useGlobalFormContext();

  // -----------------------------
  // WHEN FORM CONTEXT EXISTS
  // -----------------------------
  if (formContext) {
    const { watch, getValues, formState } = formContext;

    // Live updates on every form change
    const liveFormData = watch(); 
    const currentValues = getValues();

    const combinedData = {
      ...storeData,
      ...currentValues,
      ...liveFormData,
    };

    return {
      liveFormData,
      storeData,
      combinedData,
      currentValues,
      isDirty: formState.isDirty,
      errors: formState.errors,
      hasFormContext: true,
    };
  }

  // -----------------------------
  // FALLBACK – NO FORM PROVIDER
  // -----------------------------
  return {
    liveFormData: {},
    storeData,
    combinedData: storeData,
    currentValues: storeData,
    isDirty: false,
    errors: {},
    hasFormContext: false,
  };
};
